const ENACHUmrnUplaodActionTypes = {
	FETCH_ENACH_EXPORT_DETAILS_START: 'fetch_enach_export_details_report_Start',
	FETCH_ENACH_EXPORT_DETAILS_SUCCESS: 'fetch_enach_export_details_Success',
	FETCH_ENACH_EXPORT_DETAILS_FAILURE: 'fetch_enach_export_details_Failure',
	FETCH_ENACH_EXPORT_DETAILS_RESPONSE_RESET: 'fetch_enach_export_details_ResponseReset',
	FETCH_ENACH_EXPORT_DETAILS_RESPONSE_CHANGED: 'fetch_enach_export_details_ResponseChanged',

	FETCH_ENACH_UMRN_UPLOAD_START: 'fetch_enach_umrn_upload_report_Start',
	FETCH_ENACH_UMRN_UPLOAD_SUCCESS: 'fetch_enach_umrn_upload_Success',
	FETCH_ENACH_UMRN_UPLOAD_FAILURE: 'fetch_enach_umrn_upload_Failure',
	FETCH_ENACH_UMRN_UPLOAD_RESPONSE_RESET: 'fetch_enach_umrn_upload_ResponseReset',
	FETCH_ENACH_UMRN_UPLOAD_RESPONSE_CHANGED: 'fetch_enach_umrn_upload_ResponseChanged',

	FETCH_ENACH_PAYMENT_UPLOAD_START: 'fetch_enach_payment_upload_report_Start',
	FETCH_ENACH_PAYMENT_UPLOAD_SUCCESS: 'fetch_enach_payment_upload_Success',
	FETCH_ENACH_PAYMENT_UPLOAD_FAILURE: 'fetch_enach_payment_upload_Failure',
	FETCH_ENACH_PAYMENT_UPLOAD_RESPONSE_RESET: 'fetch_enach_payment_upload_ResponseReset',
	FETCH_ENACH_PAYMENT_UPLOAD_RESPONSE_CHANGED: 'fetch_enach_payment_upload_ResponseChanged',
};
export default ENACHUmrnUplaodActionTypes;
